import React from 'react';
import { getRange } from '../../../helpers/utilities';

export const Component = ({ ...props }) => {
    const { show = true, element: Element } = props;

    if (!show) {
        return null;
    }

    const { list = null, listKey = 'id', size = 10, listProps = null } = props;

    if (Array.isArray(list)) {
        return (
            <React.Fragment>
                {list.map((item, index) => {
                    return (
                        <Element
                            {...(listProps ? listProps(item) : item)}
                            key={item[listKey] ? item[listKey] : index}
                        />
                    );
                })}
            </React.Fragment>
        );
    }

    if (size > 0) {
        const items = getRange(1, size);
        return (
            <React.Fragment>
                {items.map((item) => (
                    <Element key={item} />
                ))}
            </React.Fragment>
        );
    }

    return <Element {...props} />;
};
